/// <reference path="../../../WebUI/typings/tsd.d.ts" />

import * as KeyCodes from "./KeyCodes";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { DialogStatus } from "../v4/Views/status/index";

/** Base class for modal dialogs. */
export class DialogBase {
    protected $el: JQuery;
    private $mask: JQuery;
    private dfd = $.Deferred();
    private $okButton: JQuery;
    private $cancelButton: JQuery;
    private $dialogCloseButton: JQuery;
    private $statusPane: JQuery;
    private status: DialogStatus;
    private lastParentFocus: React.ReactInstance

    constructor() {
        this.$mask = $('<div class="dialog-mask"></div>').appendTo($(document.body));
        this.$statusPane = $('<div class="dialog-status"></div>').appendTo($(this.$mask));
        this.$el = $('<div class="dialog" role="dialog" aria-labelledby="dialog-title" aria-modal="true"></div>').appendTo(this.$mask);
    }

    protected render(): void {
    }

    protected init(): void {
        this.$okButton = this.$el.find(".ok-button");
        this.$cancelButton = this.$el.find(".cancel-button");
        this.$dialogCloseButton = this.$el.find(".dialog-close-button");
        this.centerDialog();
        this.handleEvents();
        this.$okButton.focus();
    }

    protected handleEvents(): void {
        this.$okButton.click(() => this.onOK());
        this.$cancelButton.click(() => this.onCancel());
        this.$el.keydown(ev => this.onKeyDown(ev));
    }

    protected onKeyDown(ev: JQueryKeyEventObject): void {
        switch (ev.which) {
            case KeyCodes.KeyCodes.Enter:
                if (this.onEnterKeyPressed()) {
                    ev.preventDefault();
                }
                break;
            case KeyCodes.KeyCodes.Escape:
                if (this.$cancelButton.is(":visible") || this.$dialogCloseButton.is(":visible")) {
                    this.onEscapeKeyPressed();
                }
                ev.preventDefault();
                break;
        }
    }

    /** Handles enter key. May be Overridden to change default behavior. */
    protected onEnterKeyPressed(): boolean {
        if (this.$okButton.length > 0) {
            this.onOK();
            return true;
        } else {
            return false;
        }
    }

    /** Handles escape key. May be Overridden to change default behavior. */
    protected onEscapeKeyPressed(): void {
        this.onCancel();
    }

    private centerDialog(): void {
        var t = ($(window).height() - this.$el.outerHeight()) / 3;
        var l = ($(window).width() - this.$el.outerWidth()) / 2;
        t = Math.max(0, t);
        l = Math.max(0, l);
        this.$el.css({ top: t + 'px', left: l + 'px' });
    }

    public showDialog(_lastParentFocus?: React.ReactInstance): JQueryPromise<any> {
        this.lastParentFocus = _lastParentFocus;
        this.render();
        return this.dfd.promise();
    }

    public closeDialog(): void {
        this.$el.remove();
        this.$statusPane.remove();
        this.$mask.remove();
        this.returnFocusToParent();
    }

    private returnFocusToParent(): void {
        if (this.lastParentFocus != null){            
            const lastParentFocusElement = ReactDOM.findDOMNode(this.lastParentFocus) as HTMLElement;
            lastParentFocusElement && lastParentFocusElement.focus();
        }
    }

    /** Hides the dialogue box and shows a progress spinner. */
    public showStatus(statusMessage?: string): void {
        if (!this.$el.hasClass("dialog-hidden")) {
            this.$el.addClass("dialog-hidden");
        }
        const status = React.createElement(DialogStatus, { statusMessage: statusMessage });
        this.status = ReactDOM.render(status, this.$statusPane[0]);
        this.status.setState({ showing: true });
    }

    /** Hides the progress spinner and status message, and shows the dialogue box */
    public hideStatus(): void {
        if (this.status) {
            this.status.setState({ showing: false });
        }

        if (this.$el.hasClass("dialog-hidden")) {
            this.$el.removeClass("dialog-hidden");
        }
    }

    protected onCancel(): void {
        this.closeDialog();
        this.dfd.reject();
    }

    /** Handles OK button. Override this method and get user input, then call this base class method. */
    protected onOK(): void {
        this.closeDialog();
        this.dfd.resolve();
    }

    protected resolve<T>(...values: any[]): JQueryDeferred<T> {
        return this.dfd.resolve.apply(this.dfd, values);
    }
}



// WEBPACK FOOTER //
// ./Client/Dialogs/DialogBase.ts